import React from 'react'
import styled from 'styled-components'
import CircleNumber from './CircleNumber';
import NormalText from './NormalText';
import {media} from '../styles/Mixin'
import PropTypes from "prop-types";



export const CategoryBox = ({
    categoryName,
    categoryCount,
    className,
    onClick,
    isSelf
})=>{

    return(
        <Wrapper className={className} >
            <CategoryName text={categoryName} onClick={onClick} isSelf={isSelf} />
            <CategoryNumber number={categoryCount} onClick={onClick} isSelf={isSelf} />
        </Wrapper>
    )
}

CategoryBox.propTypes = {
    categoryName: PropTypes.string.isRequired,
    categoryCount: PropTypes.number.isRequired,
};

export default CategoryBox;

const Wrapper = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    border-bottom:${props => props.theme.borderBottom};
    ${media.deskTop`
    width:60%;
    max-width:1000px;
    padding:5px;
    `}
  ${media.mobile`
    width:70%;
    `}
    
`

const CategoryName = styled(NormalText)`
    /* cursor: ${props => props.isSelf === true ? "pointer" : "text"}; */
    cursor:pointer;
    ${media.deskTop`
        padding:10px;
    `}
  ${media.mobile`
    padding:5px;
    `}
`

const CategoryNumber = styled(CircleNumber)`
    /* cursor: ${props => props.isSelf === true ? "pointer" : "text"}; */
    cursor:pointer;
    ${media.deskTop`
        padding:10px;
    `}
  ${media.mobile`
    padding:5px;
    `}
`

